<kendo-dialog title="Upload Security Document" [width]="500" (close)="onCancel()">
  <div class="py-2">
    <p class="text-muted small mb-3">
      Upload a PDF or DOCX security document for AI-powered gap analysis against operational evidence.
    </p>

    <!-- Drop Zone -->
    <div
      class="drop-zone p-4 text-center rounded-3 mb-3"
      [class.drop-zone--active]="isDragOver()"
      [class.drop-zone--selected]="selectedFileName()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()"
      (drop)="onDrop($event)"
    >
      @if (selectedFileName()) {
        <div class="d-flex align-items-center justify-content-center gap-2">
          <span
            class="file-type-indicator"
            [class.file-type-indicator--pdf]="selectedFileType() === 'pdf'"
            [class.file-type-indicator--docx]="selectedFileType() === 'docx'"
          >
            {{ selectedFileType() | uppercase }}
          </span>
          <span class="fw-medium">{{ selectedFileName() }}</span>
          <button class="btn btn-sm btn-outline-secondary ms-2" (click)="selectedFileName.set(null); selectedFileType.set(null)">
            Remove
          </button>
        </div>
      } @else {
        <div class="mb-2 text-muted">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16">
            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
            <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
          </svg>
        </div>
        <p class="mb-1 fw-medium">Drag & drop your file here</p>
        <p class="text-muted small mb-2">or</p>
        <label class="btn btn-outline-primary btn-sm">
          Browse Files
          <input type="file" accept=".pdf,.docx" class="d-none" (change)="onFileInputChange($event)" />
        </label>
        <p class="text-muted small mt-2 mb-0">Supports PDF and DOCX files</p>
      }
    </div>

    @if (isUploading()) {
      <div class="mb-3">
        <div class="progress" style="height: 6px">
          <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 75%"></div>
        </div>
        <span class="text-muted small mt-1 d-block">Uploading document...</span>
      </div>
    }
  </div>

  <kendo-dialog-actions>
    <button class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
    <button
      class="btn btn-primary"
      [disabled]="!selectedFileName() || isUploading()"
      (click)="onUpload()"
    >
      @if (isUploading()) {
        Uploading...
      } @else {
        Upload & Analyze
      }
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
